/**
 * Animate members page hero count from 0 to data-count-to in under 2 seconds.
 * Markup: .c-page-hero__count[data-count-to] with .t-num and zero-padded start width.
 */

const DURATION_MS = 1700;

function easeOutCubic(t) {
  return 1 - (1 - t) ** 3;
}

export function initMembersHeroCount() {
  const el = document.querySelector(".c-page-hero__count[data-count-to]");
  if (!el) return;

  const rawTarget = parseInt(el.getAttribute("data-count-to") || "", 10);
  const digits = parseInt(el.getAttribute("data-count-digits") || "", 10);
  if (Number.isNaN(rawTarget) || rawTarget < 0) return;
  const target = rawTarget;
  const pad =
    Number.isFinite(digits) && digits > 0
      ? digits
      : Math.max(2, String(Math.max(target, 1)).length);

  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduced) {
    el.textContent = String(target);
    return;
  }

  const start = performance.now();

  function frame(now) {
    if (!el.isConnected) return;

    const elapsed = now - start;
    const t = Math.min(1, elapsed / DURATION_MS);
    const eased = easeOutCubic(t);
    const current = Math.round(eased * target);

    if (t >= 1) {
      el.textContent = String(target);
      return;
    }

    el.textContent = String(current).padStart(pad, "0");
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}
